import { render, staticRenderFns } from "./ProductDraftEditor.vue?vue&type=template&id=41314c6c&scoped=true"
import script from "./ProductDraftEditor.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductDraftEditor.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProductDraftEditor.vue?vue&type=style&index=0&id=41314c6c&prod&lang=scss&scoped=true"
import style1 from "./ProductDraftEditor.vue?vue&type=style&index=1&id=41314c6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41314c6c",
  null
  
)

export default component.exports